import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=6ddbaa6a"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=6ddbaa6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports